import type { InClassRecordRequest } from '@/models/interface/courseRecord';
import type {
  LiveStreamRecordPayload,
  LiveStreamRecordResponse,
  ObserveRecordReq,
  ObserveRecordRes
} from '@/models/interface/reports';
import type { ICourseRecordLiveLesson } from '@/models/interface/statistics';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class userReportsService extends ApiFactory {
  constructor() {
    super('UserReports');
  }

  getObserveRecord(params: ObserveRecordReq): Promise<ApiDataResponse<ObserveRecordRes>> {
    return super.get('ObserveRecord', params);
  }

  searchCourseRecord(
    params: InClassRecordRequest
  ): Promise<ApiDataResponse<ICourseRecordLiveLesson>> {
    return super.post('InClassRecordV2', params);
  }

  /**
   * 取得 直播上課紀錄
   * @param params - 請求參數
   * @remarks 請求參數包含分頁、時間範圍、關鍵字等過濾條件
   */
  getLiveStreamRecord(
    params: LiveStreamRecordPayload
  ): Promise<ApiDataResponse<LiveStreamRecordResponse>> {
    return super.get('LivestreamRecord', params);
  }

  /**
   * 取得 直播下載紀錄
   * @param params - 請求參數
   * @remarks 請求參數包含分頁、時間範圍、關鍵字等過濾條件
   */
  getLiveStreamDownloadRecord(
    params: LiveStreamRecordPayload
  ): Promise<ApiDataResponse<LiveStreamRecordResponse>> {
    return super.get('LivestreamDownloadRecord', params);
  }
}
